<form [formGroup]="form" class="cover-page-form" (ngSubmit)="$event.stopPropagation(); onSubmit()">
  <label class="cover-page-form-label">
    Title:
    <input formControlName="title" class="form-input_md" />
  </label>

  <label class="cover-page-form-label">
    From Number:
    <app-select
      [items]="clientNumberOptions"
      [activeItem]="form.value.fromNumber"
      [placeholder]="'Select number'"
      [customClass]="'select_l'"
      (selectChange)="form.patchValue({ fromNumber: $event })"
    ></app-select>
  </label>

  <label class="cover-page-form-label">
    Sent From:
    <input formControlName="sentFrom" class="form-input_md" />
  </label>

  <span *ngIf="isSaving" class="cover-page-form-submit-button" role="status">Loading…</span>

  <button *ngIf="!isSaving" type="submit" [disabled]="form.invalid" class="btn_primary btn_lg cover-page-form-submit-button">
    Save
  </button>
</form>
